import { toFixed } from '../../../core/services/utils/numbers';

/** Calcula a quantidade anual multiplicando a quantidade pelos 12 meses do ano */
export function calcularQuantidadeAnual(quantidade: number): number {
    quantidade = quantidade && !isNaN(quantidade) ? Number(quantidade) : 0;

    const quantidadeAnual = quantidade * 12;
    return toFixed(quantidadeAnual, 4)
}

/** Calcula o peso anual multiplicando o peso pelos 12 meses do ano */
export function calcularPesoAnual(peso: number): number {
    peso = peso && !isNaN(peso) ? Number(peso) : 0;

    const pesoAnual = peso * 12;
    return toFixed(pesoAnual, 4)
}

/** Calcula o valor anual multiplicando o valor pelos 12 meses do ano */
export function calcularValorAnual(valor: number): number {
    valor = valor && !isNaN(valor) ? Number(valor) : 0;

    const valorAnual = valor * 12;
    return toFixed(valorAnual, 2)
}
